var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6C14 8.20914 12.2091 10 10 10Z",
    fill: "#2D3643"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.625C3 17.835 3.16942 18 3.38504 18H16.615C16.8306 18 17 17.835 17 17.625C17 14.52 13.8581 12 10 12C6.14191 12 3 14.52 3 17.625Z",
    fill: "#2D3643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/MyProfile.22d5c7ef6f91d0cf4f69fdbd7b9a01a0.svg";
export { ForwardRef as ReactComponent };